module.exports = __webpack_public_path__ + "static/media/4.7dbe7723.png";